/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-10-10 15:30:38
 * @FilePath: \qctsw-vue\packages\app\src\logic\common\redBlack.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getCurrentTime } from '@qctsw/utils'
import { getRedBlackDayListApi, getRedBlackWeekListApi, getRedBlackWeekYearListApi } from '@/server'
import { LOAD_STATE } from '@/shared/types'
import { usePagination } from '@/composables/usePagination'
import type { DayRedBlackResponse, RedBlackResponse } from '@/server/types'
import { useGetRouteQuery } from '@/shared/function'

export function logicRedBlackWeekYears() {
  const state = ref(LOAD_STATE.INIT)
  const currentYear = ref<string>(getCurrentTime('YYYY'))
  const yearOptions = ref<{ label: string, value: string }[]>([])

  async function getYearList() {
    const res = await useLoadState({
      state,
      fn: () => getRedBlackWeekYearListApi(),
    })

    if (!res)
      return

    yearOptions.value = res.data.map(item => ({
      label: item.year,
      value: item.year,
    }))

    if (currentYear.value !== yearOptions.value[0].value)
      currentYear.value = yearOptions.value[0].value
  }

  return {
    currentYear,
    yearOptions,
    getYearList,
  }
}

export function logicRedBlackWeekList() {
  const page = useGetRouteQuery('page', '1')

  const data = ref<RedBlackResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '红黑榜周榜',
    pageSize: 20,
    request: (params, p = {}) => getRedBlackWeekListApi({ ...params, year: p.year }),
  })
  async function getPage(page: number | string = 1, params: { year: string }) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    const { list } = await pagination.loadPaginationData(p, params) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  return {
    page,
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}

export function logicRedBlackDayList() {
  const page = useGetRouteQuery('page', '1')

  const data = ref<DayRedBlackResponse[]>([])
  const pagination = usePagination({
    type: 'pageNumber',
    key: '红黑榜日榜',
    pageSize: 20,
    request: params => getRedBlackDayListApi({ ...params }),
  })
  async function getPage(page: number | string = 1) {
    const p = Number.isNaN(Number(page)) ? 1 : Number(page)
    const { list } = await pagination.loadPaginationData(p) || {}
    if (!list)
      return
    data.value.push(...list)
  }

  return {
    page,
    list: data,
    pagination,
    state: computed(() => pagination.pagination.status),
    getPage,
  }
}
